module.exports = ".app-container {\n  height: 100%;\n  padding: 20px; }\n  .app-container .app-title {\n    margin-top: 25px;\n    margin-bottom: 25px; }\n"